module.exports = __webpack_public_path__ + "ce4545493b9e77be0382bd19a73f0653.pdf";